import { useEffect, useRef, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import IconCropper from '../../../components/IconCropper/iconCropper';
import NotificationPreview from '../../../components/NotificationPreview/NotificationPreview';
import { ERRORS } from '../../../constants/AppConstants';
import { getAbandonedCartData, updateAbandonedCartData } from '../../../services/woocommerceService';
import getCroppedImage from '../../../Util/getCroppedImage';

export const WooAbandonedCart = () => {

    const { selectedWebsite,
        setIsDirty,
        setPathToNavigate,
        setDiscardPromptOpen,
        isDirty, 
    } = useAppContext();
    
    const bannerRef = useRef(null);

    const history = useHistory();

    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(null);

    const [message, setMessage] = useState('');
    const [messageError, setMessageError] = useState(null);
    const [messageLengthError, setMessageLengthError] = useState(null);

    const [bannerPath, setBannerPath] = useState('');
    const [bannerName, setBannerName]= useState('');
    const [openBannerCropper, setOpenBannerCropper] = useState(false);
    const [banner, setBanner] = useState(null);
    const [bannerDisplayPath, setBannerDisplayPath] = useState('');

    const [firstDelay, setFirstDelay] = useState();
    const [firstDelayActive, setFirstDelayActive] = useState(false);
    const [firstDelayInterval, setFirstDelayInterval] = useState('day');
    const [firstDelayError, setFirstDelayError] = useState(null);

    const [secondDelay, setSecondDelay] = useState();
    const [secondDelayActive, setSecondDelayActive] = useState(false);
    const [secondDelayInterval, setSecondDelayInterval] = useState('day');
    const [secondDelayError, setSecondDelayError] = useState(null);

    const [thirdDelay, setThirdDelay] = useState();
    const [thirdDelayActive, setThirdDelayActive] = useState(false);
    const [thirdDelayInterval, setThirdDelayInterval] = useState('day');
    const [thirdDelayError, setThirdDelayError] = useState(null);

    const [data, setData] = useState({});

    useEffect(() => {
        const discard = () => {
            setAbandonedCartData(data);
        }
        document.addEventListener('discardEvent', discard);

        return () => {
            document.removeEventListener('discardEvent', discard);
        }
    }, [data])

    useQuery(
        ['fetchWooAbandonedCart', selectedWebsite?.id], 
        () => getAbandonedCartData(selectedWebsite?.id),
        {
            enabled: !!selectedWebsite,
            onSuccess: (abandonedCartData) => {
                if(abandonedCartData) {
                    setData(abandonedCartData)
                    setAbandonedCartData(abandonedCartData);
                } else {
                    toast.error('Something went wrong!!');
                }
            }
        }
    );


    const handelTitleChange = (value) => {
        
        if(value.trim().length <=0 ) {
            setTitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setTitleError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 100 ) {
            setTitle(value);
        }
    }

    const handelMessageChange = (value) => {
        
        if(value.trim().length > 120 ) {
            setMessageLengthError(ERRORS.WEBSITE_MESSAGE_MAX_LENGTH);
        }
        else {
            setMessageLengthError(null)
            setMessageError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 300 ) {
            setMessage(value);
        }
    }

    const handelBannerUpload = (({target}) => {
        if(target.files && target.files[0]) {
            const url = URL.createObjectURL(target.files[0]);
            setBannerPath(url);
            setBannerName(target.files[0].name);
            setOpenBannerCropper(true);
            bannerRef.current.value = '';
            setIsDirty(true);
        }
    });

    const onCancelBannerCrop = () => {
        // if(welcomeNotification && welcomeNotification?.banner_image) {
        //     setBannerPath(welcomeNotification?.banner_image);
        // } else {
        //     setBannerPath('');
        // }
        setBannerDisplayPath('');
        setOpenBannerCropper(false);
        setBannerName('');
    }
    
    const getCroppedBanner = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            bannerPath,
            croppedAreaPixel,
            0,
            bannerName,
        );
        setBannerDisplayPath(url);
        setBannerPath(url);
        setBanner(file);
        setOpenBannerCropper(false);
    }

    const onClearBanner = () => {
        setIsDirty(true);
        setBanner(null);
        setBannerPath('');
        setBannerDisplayPath('');
        setBannerName('');
    }

    const handelFirstDelayChange = (value) => {
        setFirstDelay(value);
        if(value <= 0 ) {
            setFirstDelayError(ERRORS.ECOM_NOTIFICATION_AFTER_ERROR);
        }
        else {
            setFirstDelayError(null);
        }
        setIsDirty(true);
    }



    const handelSecondDelayChange = (value) => {
        setSecondDelay(value);
        if(value <= 0 ) {
            setSecondDelayError(ERRORS.ECOM_NOTIFICATION_AFTER_ERROR);
        }
        else {
            setSecondDelayError(null);
        }
        setIsDirty(true);
    }

    const handelThirdDelayChange = (value) => {
        setThirdDelay(value);
        if(value <= 0 ) {
            setThirdDelayError(ERRORS.ECOM_NOTIFICATION_AFTER_ERROR);
        }
        else {
            setThirdDelayError(null);
        }
        setIsDirty(true);
    }

    const onBack = () => {
        if(isDirty) {
        setPathToNavigate('/woocommerce-automation');
        setDiscardPromptOpen(true);
        } else {
            history.push('/woocommerce-automation');
        }
    }


    const setAbandonedCartData = (abandonedCartData) => {
        setTitle(abandonedCartData?.title);
        setMessage(abandonedCartData?.message);
        setBannerDisplayPath(abandonedCartData?.image);
        setFirstDelayActive(abandonedCartData?.is_first_delay_active);
        setSecondDelayActive(abandonedCartData?.is_second_delay_active);
        setThirdDelayActive(abandonedCartData?.is_third_delay_active);
        if(abandonedCartData.first_delay) {
            const delay = abandonedCartData.first_delay.split(' ');
            setFirstDelay(delay[0]);
            setFirstDelayInterval(delay[1]);
        }
        if(abandonedCartData.second_delay) {
            const delay = abandonedCartData.second_delay.split(' ');
            setSecondDelay(delay[0]);
            setSecondDelayInterval(delay[1]);
        }
        if(abandonedCartData.third_delay) {
            const delay = abandonedCartData.third_delay.split(' ');
            setThirdDelay(delay[0]);
            setThirdDelayInterval(delay[1]);
        }
    }

    const updateAbandonedCart = useMutation((event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('title', title);
        formData.append('message', message);
        if(banner) {
            formData.append('image', banner);
        } else if(!banner && !bannerPath) {
            formData.append('image', '');
        }
        formData.append('is_first_delay_active', firstDelayActive);
        if(firstDelayActive) {
            formData.append('first_delay', `${firstDelay} ${firstDelayInterval}`);
        }
        formData.append('is_second_delay_active', secondDelayActive);
        if(secondDelayActive) {
            formData.append('second_delay', `${secondDelay} ${secondDelayInterval}`);
        }
        formData.append('is_third_delay_active', thirdDelayActive);
        if(thirdDelayActive) {
            formData.append('third_delay', `${thirdDelay} ${thirdDelayInterval}`);
        }
        return updateAbandonedCartData(selectedWebsite?.id, formData)}, {
            onSuccess: (abandonedCartData) => {
                setAbandonedCartData(abandonedCartData)
                setIsDirty(false);
                toast.success('Abandoned Cart Notification details updated successfully');
            }
        }
    );

    const isSaveDisabled = () => {
        return title.length < 0 || titleError || messageError || (firstDelayActive && !firstDelay) || firstDelay <=0 || firstDelayError ||
        (secondDelayActive && !secondDelay) || secondDelay <=0 || secondDelayError || (thirdDelayActive && !thirdDelay) || thirdDelay <=0 || thirdDelayError; 
    } 
    

    return <>
        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div>
                    <h3 className="mb-0">
                        <i className="icon icon-chevron-left mr-2" onClick={onBack} ></i> 
                        Abandoned Cart Settings</h3>
                    </div>
                    <div className="d-flex justify-content-between">
                        <button className="btn btn-sm btn-danger mr-2"  >Discard</button>
                        <button className="btn btn-sm btn-primary" disabled = {isSaveDisabled()} onClick={updateAbandonedCart.mutate}>Save</button>                                         
                    </div> 
                </div>                                
            </div>
            <div className="panel-body scrollable_y">
                                {/* <div className="row">
                                    <div className="col col-md-6 col-xl-4 mb-3">
                                        <div className="box">
                                            <h6 className="medium">First notification sent after</h6>
                                            <div className="form-group">
                                                <div className="input-group-addon d-flex">
                                                    <input type="text" className="form-control" value="1" placeholder="" readonly/>
                                                    <select>
                                                        <option>Day(s)</option>
                                                        <option>Hours(s)</option>
                                                        <option>Minute(s)</option>
                                                    </select>
                                                </div>
                                                
                                            </div>
                                            <label className="toggle-control toggle-control mb-2">
                                                <input type="checkbox" checked="checked" />Active
                                                <span className="control ml-2"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col col-md-6 col-xl-4 mb-3">
                                        <div className="box">
                                            <h6 className="medium">Second notification sent after</h6>
                                            <div className="form-group">
                                                <div className="input-group-addon d-flex">
                                                    <input type="text" className="form-control" value="1" placeholder="" readonly/>
                                                    <select>
                                                        <option>Day(s)</option>
                                                        <option>Hours(s)</option>
                                                        <option>Minute(s)</option>
                                                    </select>
                                                </div>
                                                
                                            </div>
                                            <label className="toggle-control toggle-control mb-2">
                                                <input type="checkbox" checked="checked" />Active
                                                <span className="control ml-2"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col col-md-6 col-xl-4 mb-3">
                                        <div className="box">
                                            <h6 className="medium">Third notification sent after</h6>
                                            <div className="form-group">
                                                <div className="input-group-addon d-flex">
                                                    <input type="text" className="form-control" value="1" placeholder="" readonly/>
                                                    <select>
                                                        <option>Day(s)</option>
                                                        <option>Hours(s)</option>
                                                        <option>Minute(s)</option>
                                                    </select>
                                                </div>
                                                
                                            </div>
                                            <label className="toggle-control toggle-control mb-2">
                                                <input type="checkbox" checked="checked" />Active
                                                <span className="control ml-2"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div> */}
                                <div  className="row">
                                    <div className="col br-right">
                                        <h5 className="medium mb-3">Notification Settings</h5>
                                        <div className="form-group">
                                            <div className="d-flex justify-content-between">
                                                <label className="form-label text-dark medium">Notification Title *</label>
                                                <div>{title.length} / 100</div>
                                            </div>
                                            <div className="input-addon input-group-right">
                                                <i className="icon icon-edit"></i>
                                                <input
                                                    type="text"
                                                    placeholder="Product [product-name] is back in stock!"
                                                    className="form-control"
                                                    value={title}
                                                    onChange={({target}) => handelTitleChange(target.value)}
                                                    maxLength={100}    
                                                />                        
                                            </div>
                                            <span>Note:You can use the [product-name] keyword as placeholder that will be dynamically replaced with the real value.</span>
                                            { titleError && <div><span className="error-message">{titleError}</span></div>}
                                        </div>
                                        <div className="form-group">
                                            <div className="d-flex justify-content-between">
                                                <label className="form-label text-dark medium">Notification Message</label>
                                                <div>{message.length} / 300</div>
                                            </div>
                                            <div className="input-addon input-group-right">
                                                <i className="icon icon-edit"></i>
                                                <textarea
                                                    type="text"
                                                    placeholder="A product [product-name] that you follow is back in stock."
                                                    className="form-control"
                                                    value={message}
                                                    onChange={({target}) => handelMessageChange(target.value)}    
                                                    maxLength={300}
                                                ></textarea>                        
                                            </div>
                                            <span>Note: You can use the [product-name] keyword as placeholder that will be dynamically replaced with the real value.</span>
                                            { messageError && <div><span className="error-message">{messageError}</span></div>}
                                            { messageLengthError && <div><span className="error-message">{messageLengthError}</span></div>}
                                        </div>
                                        <div className="form-group">
                                            <div className="form-group">                   
                                                <label className="form-label text-dark medium">Notification Image</label>
                                                <div className="d-flex">                                                        
                                                    <div className="form-group mb-0">                                                            
                                                        <div className="d-flex align-items-center">
                                                            <div className="file-upload">                                                    
                                                                <input 
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={(event) => handelBannerUpload(event)}    
                                                                    ref={bannerRef}
                                                                />
                                                                <i className="icon icon-file"></i>
                                                                Select File
                                                            </div>
                                                            {bannerDisplayPath && <span className="mx-2 image-name">{bannerDisplayPath}</span>}  
                                                        </div>
                                                    </div>
                                                    { bannerDisplayPath && <button className="btn ml-2 btn-grey" onClick={() => onClearBanner()} ><i className="icon icon-close mr-2"></i>Clear</button>}
                                                    {/* <button className="btn btn-grey mx-2"><i className="icon icon-search mr-2"></i>Search</button>
                                                    <button className="btn btn-grey"><i className="icon icon-close mr-2"></i>Clear</button> */}
                                                </div> 
                                        
                                                <span>Note: This image is sent together with the reminder notification. </span>
                                            </div>                                            
                                        </div>
                                        <div className="cart-notification-wrapper">
                                            <div className="box">
                                                <h6 className="medium">First notification sent after</h6>
                                                <div className="form-group">
                                                    <div className="input-group-addon d-flex">
                                                        <input type="number" 
                                                            className="form-control" 
                                                            value={firstDelay} 
                                                            placeholder=""
                                                            onChange={({target}) => handelFirstDelayChange(target.value)}
                                                            disabled={!firstDelayActive}
                                                            />
                                                        <select disabled={!firstDelayActive} value={firstDelayInterval} onChange={({target}) => setFirstDelayInterval(target.value)} >
                                                            <option value='day' >Day(s)</option>
                                                            <option value='hour' >Hours(s)</option>
                                                            <option value='minute' >Minute(s)</option>
                                                        </select>
                                                    </div>
                                                    { firstDelayError && <div><span className="error-message">{firstDelayError}</span></div>}
                                                </div>
                                                <label className="toggle-control toggle-control mb-2">
                                                    <input type="checkbox" checked={firstDelayActive} onChange={ () => setFirstDelayActive(!firstDelayActive)}/>Active
                                                    <span className="control ml-2"></span>
                                                </label>
                                            </div>
                                            <div className="box">
                                                <h6 className="medium">Second notification sent after</h6>
                                                <div className="form-group">
                                                    <div className="input-group-addon d-flex">
                                                        <input type="number" 
                                                        className="form-control" 
                                                        value={secondDelay} 
                                                        placeholder="" 
                                                        disabled={!secondDelayActive}
                                                        onChange={({target}) => handelSecondDelayChange(target.value)}/>
                                                        <select disabled={!secondDelayActive} value={secondDelayInterval} onChange={({target}) => setSecondDelayInterval(target.value)}>
                                                            <option value='day' >Day(s)</option>
                                                            <option value='hour' >Hours(s)</option>
                                                            <option value='minute' >Minute(s)</option>
                                                        </select>
                                                    </div>
                                                    { secondDelayError && <div><span className="error-message">{secondDelayError}</span></div>}                                                    
                                                </div>
                                                <label className="toggle-control toggle-control mb-2">
                                                    <input type="checkbox" checked={secondDelayActive} onChange={ () => setSecondDelayActive(!secondDelayActive)} />Active
                                                    <span className="control ml-2"></span>
                                                </label>
                                            </div>
                                            <div className="box">
                                                <h6 className="medium">Third notification sent after</h6>
                                                <div className="form-group">
                                                    <div className="input-group-addon d-flex">
                                                        <input type="number" 
                                                        className="form-control" 
                                                        value={thirdDelay} 
                                                        placeholder="" 
                                                        onChange={({target}) => handelThirdDelayChange(target.value)}
                                                        disabled={!thirdDelayActive}
                                                        />
                                                        <select disabled={!thirdDelayActive} value={thirdDelayInterval} onChange={({target}) => setThirdDelayInterval(target.value)} >
                                                            <option value='day' >Day(s)</option>
                                                            <option value='hour' >Hours(s)</option>
                                                            <option value='minute' >Minute(s)</option>
                                                        </select>
                                                    </div>
                                                    { thirdDelayError && <div><span className="error-message">{thirdDelayError}</span></div>}   
                                                </div>
                                                <label className="toggle-control toggle-control mb-2" >
                                                    <input type="checkbox" checked={thirdDelayActive} onChange={ () => setThirdDelayActive(!thirdDelayActive)} />Active
                                                    <span className="control ml-2"></span>
                                                </label>
                                            </div>
                                        </div>                                                                                
                                    </div>
                                    <NotificationPreview
                                        title={title}
                                        message={message}
                                        icon={selectedWebsite?.logo}
                                        is_cta_enabled = {false}
                                        isCTA2Enabled = {false}
                                        button={''}
                                        banner={bannerDisplayPath}
                                        addl_button={''}
                                    />                                    
                                </div>
                            </div>
                        </div>

                        { openBannerCropper && <IconCropper
                        open={openBannerCropper} 
                        onClose={onCancelBannerCrop} 
                        url={bannerPath} 
                        onSave={getCroppedBanner}
                        aspect={2/1}
                    />
        }
    </>
}

export default WooAbandonedCart;